<script>
  import { onMount } from "svelte";
  import Intersection from "$lib/Intersection.svelte";

  export let image;
  export let lazy = true;

  let className = "";
  export { className as class };

  export let intersectionClass = "";

  let img;

  const thumb = image["xs"];
  const extension = image.url
    .split(".")
    [image.url.split(".").length - 1].split("?")[0];

  $: srcset = (() => {
    const sizes = ["main", "xl", "lg", "md", "sm"];
    image.main = image;
    return sizes
      .filter((size) => image[size])
      .map(
        (size) =>
          `${image[size].url
            .replace("compress,", "")
            .replace(",compress", "")} ${image[size].dimensions.width}w`,
      )
      .join(", ");
  })();

  $: sizes = (() => {
    const sizes = ["main", "xl", "lg", "md", "sm"];
    image.main = image;
    return sizes
      .filter((size) => image[size])
      .map(
        (size) =>
          `(max-width: ${image[size].dimensions.width}px) ${image[size].dimensions.width}px`,
      )
      .join(", ");
  })();
</script>

{#if image}
  {#if extension === "svg" || !thumb}
    <img
      width={image.dimensions.width}
      height={image.dimensions.height}
      class="block w-full {className}"
      src={image.url.replace("compress,", "")}
      alt={image.alt || image.title}
    />
  {:else}
    <Intersection
      let:intersecting
      top={500}
      bottom={500}
      left={2000}
      right={2000}
      class={intersectionClass}
    >
      <img
        class="block w-full {className}"
        bind:this={img}
        src={thumb.url.replace("compress,", "")}
        width={image.dimensions.width}
        height={image.dimensions.height}
        alt={image.alt || image.title}
        srcset={intersecting || !lazy || !thumb ? srcset : ""}
        {sizes}
      />
    </Intersection>
  {/if}
{/if}
